module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABsAAAAZCAYAAADAHFVeAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAAO5JREFUeNq8ltENgyAQhrXpe92gblA7QekEZRRHYARHcISO4Ah2A7uBG1zvEkwMQuUQ+JL/xRz+3h0elABQMKlQcxHAKWBNi6pzmRF9LjOBeugMs2RGKN2/LGYXbjmPmBEvlMxlRnS+5QwxM7f9VfdvlzLgp3YteKKGXGYfVJO6Zwu3vXLGzGzhjhpTZ7benVHK2HjEOEcZ10wwRtn2ZKCeeaoHHm/zHT4mNWqEMCTHjIJnCIfWVj5mCuLQ/TOjLxkgLsJmJg6WzcVkmrWQFnXWZ1GvD0IOX9RkeT46rnoDzUa5mgy2wNk167j8BBgAm4/bD4t2UoMAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/resource/home/arrow5.png
// module id = OTYv
// module chunks = 50